export default "__VITE_PUBLIC_ASSET__d66ff0a8__"